import _ from 'underscore';

export const getPromptSuggestions = (response) => {
  const { recommendations } = response || {};
  const recommendation = _.find(recommendations, rec => rec.campaignType === 'Pmax');
  if (!recommendation || _.isEmpty(recommendation.longHeadlines)) {
    return [];
  }
  return _.compact(recommendation.longHeadlines.map(headline => headline.text));
};

export const getAdSuggestions = (response) => {
  const { recommendations = [], businessDetails = {} } = response || {};
  const recommendation = _.find(recommendations, rec => rec.campaignType === 'Pmax');

  if (!recommendation) {
    return null;
  }

  const imageUrl = !_.isEmpty(recommendation.imageAssets) ? recommendation.imageAssets[0].url : '';
  let adData = {};
  const businessName = businessDetails.businessName || '';
  const shortHeadline = !_.isEmpty(recommendation.shortHeadlines) ? recommendation.shortHeadlines[0].text : '';
  const longHeadline = !_.isEmpty(recommendation.longHeadlines) ? recommendation.longHeadlines[0].text : '';
  const description = !_.isEmpty(recommendation.descriptions) ? recommendation.descriptions[0].text : '';
  const allShortHeadlines = !_.isEmpty(recommendation.shortHeadlines)
    ? recommendation.shortHeadlines.map(sh => sh.text) : [];

  if (shortHeadline || longHeadline || description) {
    adData = {
      businessName,
      shortHeadline,
      allShortHeadlines,
      longHeadline,
      description,
    };
  }

  return {
    imageUrl,
    adData,
  };
};
